import makeStyles from '@material-ui/core/styles/makeStyles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { color } from '../../../app/theme';
import icInLine from '../../../assets/images/svg/ic_in_line_20.svg';
import Dropdown from '../../shared/Dropdown';
import TextFieldSearch from '../../shared/TextFieldSearch';
import ScheduledUpdateModal from './ScheduledUpdateModal';

const useStyles = makeStyles(
  () => ({
    searchContainer: {
      margin: '16px 0',
      display: 'flex',
      alignItems: 'center',
    },
    search: {
      '&:nth-child(1)': {
        width: 413,
      },
    },
    dropdown: {
      width: 186,
      margin: '0 8px',
    },
    scheduleUpdateButton: {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      color: color.$2,
      fontSize: '15px',
      lineHeight: 1,
      '& > img': {
        marginRight: 4,
      },
    },
  }),
  {
    name: 'Search',
  },
);

const Search = ({ dataType, query, onChangeSearch, onChangeStatus }) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const { pathKey } = useSelector(store => store.aiBot);
  const { status } = query;
  const typeMenuItems = [
    { text: t(`${pathKey}:statusTypes.all`), value: 'all' },
    { text: t(`${pathKey}:statusTypes.done`), value: 'done' },
    { text: t(`${pathKey}:statusTypes.embedding`), value: 'embedding' },
    { text: t(`${pathKey}:statusTypes.error`), value: 'error' },
  ];

  function handleOnEnter(v) {
    onChangeSearch(v);
  }

  function handleOnChange(v) {
    if (v === '' || v === null) {
      handleOnEnter(v);
    }
  }

  return (
    <div className={classes.searchContainer}>
      <TextFieldSearch
        className={classes.search}
        placeholder={t(`${pathKey}:search-${dataType}`)}
        onEnter={handleOnEnter}
        onChange={handleOnChange}
      />
      <Dropdown
        className={classes.dropdown}
        menuItems={typeMenuItems}
        value={status}
        onChange={onChangeStatus}
      />
      {dataType === 'web' && (
        <>
          <div
            className={classes.scheduleUpdateButton}
            onClick={() => setIsOpen(true)}
          >
            <img src={icInLine} alt="Search-icInLine" />
            {t(`${pathKey}:scheduledUpdate`)}
          </div>
          {isOpen && (
            <ScheduledUpdateModal
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
            />
          )}
        </>
      )}
    </div>
  );
};

export default Search;
